import { render, staticRenderFns } from "./suifang-edit.vue?vue&type=template&id=9e457b54&scoped=true&"
import script from "./suifang-edit.vue?vue&type=script&lang=ts&"
export * from "./suifang-edit.vue?vue&type=script&lang=ts&"
import style0 from "./suifang-edit.vue?vue&type=style&index=0&id=9e457b54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e457b54",
  null
  
)

export default component.exports